import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Button from "../../forms/Button/Button";
import { GET_STARTED } from "../../../routes/paths";
import bgImg from "../../../assets/images/homePage/why-real-grass.jpg";

import styles from "./styles.module.scss";
import { useLocalizedPath } from "../../../seo/useLocalizedPath";

const WhyRealGrass = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();

  return (
    <div className={styles.whyRealGrass}>
      <div className={styles.infoWrapper}>
        <h2>{t("whyRealGrass")}</h2>
        <div className={styles.content}>
          <p>
            {t("whyRealGrassText1.txt1")}{" "}
            <strong>{t("whyRealGrassText1.txt2")}</strong>{" "}
            {t("whyRealGrassText1.txt3")}{" "}
            <strong>{t("whyRealGrassText1.txt4")}</strong>
          </p>
          <p>
            {t("whyRealGrassText2.txt1")}{" "}
            <strong>{t("whyRealGrassText2.txt2")}</strong>,{" "}
            {t("whyRealGrassText2.txt3")}
          </p>
        </div>
        <Link to={localizePath(GET_STARTED)}>
        <Button>{t("shopGrass")}</Button>
        </Link>
      </div>
      <div className={styles.imgWrapper}>
        <img src={bgImg} alt="" />
      </div>
    </div>
  );
};

export default WhyRealGrass;
